import { useState } from "react";
import AppRoutes from "./routes/AppRoutes";
import { Toaster } from "react-hot-toast";

function App() {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [logoutFunction, setLogoutFunction] = useState(null);

  // Make functions available globally
  useState(() => {
    window.showLogoutConfirm = (logoutHandler) => {
      setLogoutFunction(() => logoutHandler);
      setShowLogoutConfirm(true);
    };
  }, []);

  const handleLogout = () => {
    if (logoutFunction) {
      logoutFunction();
    }
    setShowLogoutConfirm(false);
  };

  return (
    <>
      <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
      <div className="min-h-screen font-sora">
        <AppRoutes />
      </div>

      {/* Logout Popup */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-4">
                <i className="fa fa-sign-out text-blue-600 text-xl"></i>
              </div>
              
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Confirm Logout
              </h3>
              
              <p className="text-gray-600 mb-6">
                Are you sure you want to logout?
              </p>
              
              <div className="flex gap-3 justify-center">
                <button
                  onClick={() => setShowLogoutConfirm(false)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={handleLogout}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default App;